// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"94e3cffb","95":"bfcbedf5","239":"33919ad8","277":"64150500","527":"0637c560","732":"c59bd6ac","752":"78746099","861":"d93b34ea","977":"8a87ee29"}[chunkId] + ".chunk.js";
};